import * as React from "react";
import { Button } from "reactstrap";
import { useHistory } from "react-router-dom";
import { basePath } from "../settings";

const FindJob: React.FC<{}> = () => {

    const history = useHistory();
    const inputRef = React.useRef<HTMLInputElement>(null);
    
    const handleSubmit = React.useCallback((e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        const jobId = inputRef.current?.value ?? "";
        if (jobId !== "") {
            history.push(`${basePath}/job/${encodeURIComponent(jobId)}`);
        }
    }, [history]);
    
    return <form className="ll-find-job form-inline" onSubmit={handleSubmit}>
            <span>Job ID:</span>
            <input type="search" placeholder="e.g. xxxxxx" className="form-control"
                ref={inputRef}
            />
            <Button type="submit">Find job</Button>
        </form>
}

export default FindJob;
